import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export function setVendorLogo(relationship, logoUrl) {
    return _object_spread_props(_object_spread({}, relationship), {
        vendor: _object_spread_props(_object_spread({}, relationship.vendor), {
            logoUrl
        })
    });
}
export function withoutSigningPolicy(_0) {
    let { signingPolicy: _signingPolicy } = _0, relationship = _object_without_properties(_0, [
        "signingPolicy"
    ]);
    return relationship;
}
